<template>
  <layout name="Settings">
    <div>
      <VSettingsSidebarLayoutHeading title="Preferences" />

      <div class="org-general-form__wrapper">
        <AccountPreferencesForm />
      </div>

      <VHr :height="1" color="rgba(197,197,197,0.5)"> </VHr>

      <AccountProfilePhotoUploader />

      <VHr :height="1" color="rgba(197,197,197,0.5)"> </VHr>

      <div class="org-general-form__wrapper">
        <AccountChangePasswordForm />
      </div>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";

import VSettingsSidebarLayoutHeading from "@/components/VSettingsSidebarLayoutHeading";
import AccountPreferencesForm from "@/components/AccountPreferencesForm";
import AccountChangePasswordForm from "@/components/AccountChangePasswordForm";
import AccountProfilePhotoUploader from "@/components/AccountProfilePhotoUploader";
import VHr from "@/components/VHr";

export default Vue.component("AccountPreferences", {
  metaInfo: {
    title: "Settings - Preferences"
  },

  components: {
    Layout,
    VSettingsSidebarLayoutHeading,
    AccountPreferencesForm,
    VHr,
    AccountProfilePhotoUploader,
    AccountChangePasswordForm
  }
});
</script>
